import VimeoPlayer from "@vimeo/player";
import { prefersReducedMotion } from "../../Shared/Utilities/userPreferences";

const hasVideo: boolean =
  document.querySelectorAll<HTMLElement>("[data-landing-page-hero] iframe") != null;

if (hasVideo) {
  const landingPageHeroes = document.querySelectorAll<HTMLElement>(
    "[data-landing-page-hero]"
  );

  landingPageHeroes.forEach(landingPageHero => {
    const video = landingPageHero.querySelector<HTMLElement>("iframe");
    if (video) {
      const videoPlayer = new VimeoPlayer(video);

      const playPauseButton = landingPageHero.querySelector<HTMLElement>(
        "[data-js-play-pause-button]"
      );

      if (playPauseButton) {
        playPauseButton.addEventListener("click", () => {
          const playButton = playPauseButton.querySelector<HTMLElement>(
            "[data-js-symbol-name='play']"
          );
          const pauseButton = playPauseButton.querySelector<HTMLElement>(
            "[data-js-symbol-name='pause']"
          );

          if (playButton && pauseButton) {
            playButton.classList.toggle("hidden");
            pauseButton.classList.toggle("hidden");

            videoPlayer.getPaused().then(paused => {
              if (paused) {
                videoPlayer.play();
              } else {
                videoPlayer.pause();
              }
            });
          }
        });
      }

      if (!prefersReducedMotion()) {
        videoPlayer.on("loaded", () => {
          videoPlayer.play();
        });
      }
    }
  });
}
